import { getOwnerFromDMR, getUserFromDMR, } from '@debbie/common/dist/bespoke/apcoa/index.js';
import { VoucherCategory } from '@debbie/common/dist/economy/vouchers/index.js';
import { addressToString } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { useDMR, useFee } from '@debbie/cortex/dist/bespoke/apcoa/index.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import moment from 'moment';
import React from 'react';
import THEME from '../../../theme.js';
import Alert from '../../Alert.js';
import Button from '../../Button.js';
import { Col, Row } from '../../Grid/index.js';
import PlaceholderLoader from '../../PlaceholderLoader.js';
import Well from '../../Well.js';
const APCOAAddDMRUser = (props) => {
    const { caseId } = props;
    const caseVouchers_ = useCaseVouchersByCase(caseId, { getDeleted: true });
    const caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const principalCaseVoucher = caseVouchers?.find((caseVoucher) => caseVoucher.category === VoucherCategory.PRINCIPAL &&
        caseVoucher.referenceId);
    const feeLoadable = useFee(principalCaseVoucher?.referenceId);
    const fee = feeLoadable && h.isLoaded(feeLoadable) ? feeLoadable.data : null;
    const dmrLoadable = useDMR(principalCaseVoucher?.referenceId, fee?.registrationNo);
    const dmr = dmrLoadable && h.isLoaded(dmrLoadable) ? dmrLoadable.data : null;
    return (React.createElement("div", { style: { marginBottom: '20px' } },
        React.createElement("h3", null, "Foresl\u00E5et"),
        React.createElement("br", null),
        dmr ? (React.createElement(Row, null,
            React.createElement(Col, { width: "6" },
                React.createElement(Preview, { user: getOwnerFromDMR(dmr), onSelect: props.onSelect })),
            React.createElement(Col, { width: "6" },
                React.createElement(Preview, { user: getUserFromDMR(dmr), onSelect: props.onSelect })))) : h.isError(dmrLoadable) || !principalCaseVoucher ? (React.createElement(Alert, { message: 'Dataen kunne ikke hentes.', style: {
                backgroundColor: THEME.DANGEROUS,
            }, size: "small" })) : (React.createElement(PlaceholderLoader, null))));
};
export default APCOAAddDMRUser;
const Preview = (props) => {
    const select = useMutation(() => props.onSelect(props.user), {
        onError: () => {
            alert('Error');
        },
    });
    return (React.createElement(Well, null,
        React.createElement("h3", { style: {
                textTransform: 'uppercase',
                color: THEME.COLOR_ACCENT,
            } }, props.user.description),
        React.createElement("p", null,
            React.createElement("b", null, props.user.name),
            " (",
            props.user.isCompany ? 'Virksomhed' : 'Privatperson',
            ")",
            React.createElement("br", null),
            moment(props.user.birthdate).format(THEME.DATE_FORMAT),
            React.createElement("br", null),
            props.user.address && addressToString(props.user.address),
            props.user.cvr && (React.createElement(React.Fragment, null,
                React.createElement("br", null),
                "CVR: ",
                props.user.cvr))),
        React.createElement(Button, { theme: "light", loading: select.isLoading, onClick: () => select.mutate() }, "V\u00E6lg")));
};
//# sourceMappingURL=APCOAAddDMRUser.js.map